import React from "react";
import { ChevronDown } from "lucide-react";
import "./topbar.css";
import logo from "../images/Mihailo.svg";
import scrollTopPage from "../../global";

function Topbar({ menuOpen, setMenuOpen }) {
  return (
    <div className={"topbar" + (menuOpen ? " active" : "")}>
      <div className="topbar-box">
        <a onClick={scrollTopPage} href="/">
          <img className="logo" src={logo} alt="Logo" />
        </a>

        <nav className="topbar-nav">
          <a onClick={scrollTopPage} href="/" className="topbar-link">Početna</a>
          <a onClick={scrollTopPage} href="/biografija/" className="topbar-link">Biografija</a>

          <div className="topbar-dropdown">
            <span className="topbar-link topbar-dropdown-trigger">
              Usluge
              <ChevronDown className="topbar-dropdown-arrow" size={13} strokeWidth={2} />
            </span>
            <div className="topbar-dropdown-menu">
              <div className="topbar-dropdown-inner">
                <a onClick={scrollTopPage} href="/trening-uzivo/" className="topbar-dropdown-item">
                  Uživo trening
                </a>
                <a onClick={scrollTopPage} href="/online-trening/" className="topbar-dropdown-item">
                  Online trening
                </a>
                <a onClick={scrollTopPage} href="/plan-ishrane/" className="topbar-dropdown-item">
                  Plan ishrane
                </a>
              </div>
            </div>
          </div>

          <a onClick={scrollTopPage} href="/transformacije/" className="topbar-link">Transformacije</a>
          <a onClick={scrollTopPage} href="/kontakt/" className="topbar-link">Kontakt</a>
        </nav>

        <div className="topbar-right">
          <a onClick={scrollTopPage} href="/kontakt/" className="topbar-cta">Zakaži trening</a>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="burger-menu"
            aria-label="Otvori meni"
          >
            <div className={"line" + (menuOpen ? " line--top-open" : "")} />
            <div className={"line" + (menuOpen ? " line--bot-open" : "")} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
